<div class="main-page cadastros journey-main">
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-12 my-2">
        <h1>Relatório de Vídeo e Foto</h1>
      </div>
    </div>
    <div
      style="
        background-color: #1e3f7a;
        padding: 10px 20px;
        border-radius: 4px;
        margin-bottom: 20px;
      "
      class="d-flex justify-content-between align-items-center flex-wrap"
    >
      <div>
        <button mat-button (click)="onOpenDialogFilter()" style="color: white">
          <mat-icon style="color: white">filter_list</mat-icon>
          Filtrar
        </button>
      </div>
      <div>
        <button
          mat-stroked-button
          (click)="exportExcel()"
          style="color: white; border-color: white; margin-right: 10px"
        >
          <mat-icon style="color: white">table_view</mat-icon>
          Excel
        </button>
        <button
          mat-stroked-button
          (click)="exportPdf()"
          style="color: white; border-color: white"
        >
          <mat-icon style="color: white">picture_as_pdf</mat-icon>
          PDF
        </button>
      </div>
    </div>
    <mat-horizontal-stepper [linear]="true" #stepper>
      <mat-step>
        <!-- Analítico -->
        <p-table
          [value]="this.resultadoAnalitico"
          tableStyleClass="tableAnalitico"
        >
          <ng-template pTemplate="header">
            <tr [hidden]="this.resultadoAnalitico.length == 0" [ngClass]="this.filterDialog == true ? '' : 'sticky-top'">
              <th style="text-align: center !important; border: none">Data</th>
              <th style="text-align: center !important; border: none">Placa</th>
              <th style="text-align: center !important; border: none">Tipo de Câmera</th>
              <th style="text-align: center !important; border: none">Evento</th>
              <th style="text-align: center !important; border: none">Visualizar Arquivo</th>
              <th style="text-align: center !important; border: none">Localização</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowdata>
            <tr>
              <td style="text-align: center !important; border: none" align="center" valign="middle">
                {{ rowdata["date"] || rowdata["positionDate"] }}
              </td>
              <td style="text-align: center !important; border: none" align="center" valign="middle">
                {{ rowdata["plate"] || rowdata["placa"] }}
              </td>
              <td style="text-align: center !important; border: none" align="center" valign="middle">
                {{ rowdata["camera"] || rowdata["sourceDevice"] || rowdata["getSourceDevice"] }}
              </td>
              <td style="text-align: center !important; border: none" align="center" valign="middle">
                {{ rowdata["event"] || rowdata["sourceEvent"] || rowdata["getSourceEvent"] }}
              </td>
              <td style="text-align: center !important; border: none" align="center" valign="middle">
                <button class="btn btn-link" (click)="viewFromRow(rowdata)" matTooltip="Visualizar">
                  <img height="15" src="assets/img/view.svg" alt="visualizar" />
                </button>
              </td>
              <td style="text-align: center !important; border: none" align="center" valign="middle">
                <span *ngIf="rowdata.latitude && rowdata.longitude">
                  <a class="btn btn-link">
                    <img (click)="openMap(rowdata.latitude, rowdata.longitude)" height="15" src="assets/img/view.svg" alt="" />
                  </a>
                </span>
                <span *ngIf="!rowdata.latitude || !rowdata.longitude">-</span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>

<p-sidebar [(visible)]="this.filterDialog" position="right">
  <div style="margin-bottom: 20px">
    <span>Filtros</span>
  </div>
  <form [formGroup]="this.consultaFormGroup">
    <div class="form-row">
      <div class="form-group col-lg-12">
        <mat-form-field appearance="outline">
          <mat-label>Data Início</mat-label>
          <input
            formControlName="dataInicio"
            type="datetime-local"
            step="1"
            matInput
            placeholder="Inicio"
            required
          />
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-lg-12">
        <mat-form-field appearance="outline">
          <mat-label>Data Fim</mat-label>
          <input
            formControlName="dataFim"
            type="datetime-local"
            step="1"
            matInput
            placeholder="Fim"
            required
          />
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-lg-12">
        <mat-form-field appearance="outline">
          <mat-label>Tipo de Empresa</mat-label>
          <mat-select
            formControlName="selecaoEmpresa"
            [(value)]="empresaFilterSelected"
            [(ngModel)]="empresaFilterSelected"
            (selectionChange)="this.filterCompanyReports()"
          >
            <mat-option
              *ngFor="let type of companiesSelect"
              [value]="type.name"
            >
              {{ type.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-lg-12">
        <mat-form-field appearance="outline">
          <mat-label>Matriz/Divisão/Filial</mat-label>
          <input
            type="text"
            matInput
            [formControl]="controlEmpresa"
            [matAutocomplete]="autoEmpresa"
            required
          />
          <mat-autocomplete
            #autoEmpresa="matAutocomplete"
            [displayWith]="displayEmpresa"
          >
            <mat-option
              *ngFor="let type of this.companiesFilter"
              [value]="type"
            >
              {{ type.nmNome }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-lg-12">
        <mat-form-field appearance="outline" *ngIf="controlEmpresa.value != ''">
          <mat-label>Placa / Frota</mat-label>
          <input
            type="text"
            matInput
            [formControl]="controlVeiculoInput"
            [matAutocomplete]="autoVeiculo"
            placeholder="Digite para filtrar ou selecione"
            required
          />
          <mat-autocomplete
            #autoVeiculo="matAutocomplete"
            [displayWith]="displayVeiculo"
            (optionSelected)="onVeiculoSelected($event)"
          >
            <mat-option (click)="toggleSelectAll()" class="select-all-option">
              <mat-checkbox 
                [checked]="isAllSelected()" 
                [indeterminate]="isIndeterminate()"
                (click)="$event.stopPropagation()"
                (change)="toggleSelectAll()"
                class="select-all-checkbox">
              </mat-checkbox>
              <span class="select-all-text">
                <strong>{{ isAllSelected() ? 'Deselecionar Todos' : 'Selecionar Todos' }}</strong>
              </span>
            </mat-option>
            <mat-option
              *ngFor="let vehicle of this.vehiclesFiltered | async"
              (click)="toggleVehicleSelection(vehicle)"
              class="vehicle-option"
            >
              <mat-checkbox 
                [checked]="isVehicleSelected(vehicle)"
                (click)="$event.stopPropagation()"
                (change)="toggleVehicleSelection(vehicle)"
                class="vehicle-checkbox">
              </mat-checkbox>
              <span class="vehicle-text">
                {{ vehicle.cdPlaca }}/{{ vehicle.frota }}
              </span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <!-- Mostrar veículos selecionados -->
    <div class="form-row" *ngIf="selectedVehicles.length > 0">
      <div class="form-group col-lg-12">
        <div class="selected-vehicles">
          <label>Veículos Selecionados ({{ selectedVehicles.length }}):</label>
          <div class="vehicle-chips">
            <mat-chip-list>
              <mat-chip
                *ngFor="let vehicle of selectedVehicles"
                [removable]="true"
                (removed)="removeVehicle(vehicle)"
              >
                {{ vehicle.cdPlaca }}/{{ vehicle.frota }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            </mat-chip-list>
          </div>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-lg-12">
        <button 
          type="submit" 
          (click)="onConsultar()"
          [disabled]="!isFormValid()"
        >
          Consultar
        </button>
      </div>
    </div>
  </form>
</p-sidebar>
